import { mergeStyleSets } from '@uifabric/merge-styles';

//tslint:disable-next-line
const topHeaderClassNames = (): { [key: string]: string } => mergeStyleSets({
  topHeader: {
    backgroundColor: '#000',
    paddingTop: 24,
    selectors: {
      '@media (max-width: 640px)': {
        paddingBottom: 6
      },
      '@media screen and (-ms-high-contrast: black-on-white)': {
        selectors: {
          img: {
            backgroundColor: '#000'
          }
        }
      }
    }
  },
  upperRight: {
    float: 'right',
    selectors: {
      a: {
      }
    }
  },
  user: {
    display: 'inline-flex'
  },
  navMenuButton: {
    color: '#FFF',
    selectors: {
      '@media (min-width: 640px)': {
        display: 'none'
      }
    }
  },
  headerNav: {
    position: 'relative',
    listStyleType: 'none',
    height: 45,
    selectors: {
      a: {
        display: 'inline-block',
        fontSize: 15,
        lineHeight: 45,
        color: '#FFF',
        textDecoration: 'none',
        paddingLeft: 16,
        paddingRight: 16,
        height: 45,
        selectors: {
          ':hover': {
            backgroundColor: '#393939'
          },
          '@media (max-width: 640px)': {
            width: '100%',
            borderTop: '1px solid #FFF',
            backgroundColor: '#000',
            position: 'relative',
            zIndex: 100
          }
        }
      },
      '@media (max-width: 640px)': {
        display: 'none',
        width: '100%',
        top: 6,
        height: 0,
        paddingLeft: 0,
        paddingRight: 0
      }
    }
  },
  logoDiv: {
    marginBottom: 8
  },
  expand: {
    display: 'block'
  }
});

export default topHeaderClassNames;
